export interface CurrentPlan {
  client_code: string;
  client_group_code: string;
  plan_category: string;
  plan_number: string;
  company_code: string;
  scheme_code: string;
  reference_number: string;
  dd_amount?: number;
  dd_details?: {
    sort_code: string;
    account_number: string;
    name: string;
    nom_pay_day?: number | string;
    payment_token?: string;
  };
  monthly_cost?: number;
}

export const CurrentPlan = undefined;
